import { motion } from "framer-motion";
import { Container } from "@/components/Container/Container";
import { Section } from "@/components/Section/Section";
import { Reveal } from "@/components/Reveal/Reveal";
import { staggerContainer, staggerItem } from "@/lib/motion";
import { whatWeGoFor } from "@/spiel/whatWeGoFor";
import styles from "./WhatWeGoFor.module.scss";

export const WhatWeGoFor = () => (
  <Section id="go-for">
    <Container>
      <Reveal>
        <h2 className={styles.heading}>{whatWeGoFor.heading}</h2>
      </Reveal>

      <motion.ul
        className={styles.list}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        variants={staggerContainer}
      >
        {whatWeGoFor.items.map((item) => (
          <motion.li key={item.slice(0, 24)} className={styles.item} variants={staggerItem}>
            {item}
          </motion.li>
        ))}
      </motion.ul>
    </Container>
  </Section>
);
